import { Routes } from '@angular/router';
import { ExperimentComponent } from '@components/experiment/experiment.component';
import { ExperimentCreateComponent } from '@components/experiment-create/experiment-create.component';

export const routes: Routes = [
    {
        path: 'experiment/create', component: ExperimentCreateComponent
    },
    {
        path: 'experiment/id/:id', component: ExperimentComponent
    }
];
